import { render, staticRenderFns } from "./PayeeSelector.vue?vue&type=template&id=1d35caf3&"
import script from "./PayeeSelector.vue?vue&type=script&lang=ts&"
export * from "./PayeeSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports